import BaseAtomView from 'views/atoms/base-atom-view';
import ControlBarButtonTemplate from './templates/control-bar-button-atom';
import TippyService from 'services/loader-handler-services/tippy-loader-service';
import $ from 'jquery';
import utils from 'lib/utils';

const ControlBarButtonAtomView = BaseAtomView.extend({
  template: ControlBarButtonTemplate,
  initialize: function () {
    this.utils = utils;
    BaseAtomView.prototype.initialize.apply(this, arguments);
    this.subscribeEvent(`add:tooltip:${this.model.get('cid')}`, this.createTooltip);
  },
  render: function () {
    if (this.model.get('onClick')) {
      this.delegate('click', `#${this.model.get('cid')}-${this.model.get('id')}`, this.model.get('onClick'));
    }
    BaseAtomView.prototype.render.apply(this, arguments);
  },
  createTooltip: function () {
    if (!this.model.has('tippyConfig')) {
      return;
    }

    const $popoverContainer = $(
      `.btn-controlbar__popover-${this.model.get('cid')}-${this.model.get('id')}`
    );

    const onMount = function (instance) {
      const $popper = $(instance.popper);
      $popper.find('a').first().trigger('focus');
      this.publishEvent('tippy:show');
      this.model.get('tippyConfig')?.onMount && this.model.get('tippyConfig').onMount(instance);
    };
    const onShow = function (instance) {
      $popoverContainer.attr('aria-hidden', 'false');
      this.model.get('tippyConfig')?.onShow && this.model.get('tippyConfig').onShow(instance);
    };
    const onHide = function (instance) {
      $popoverContainer.attr('aria-hidden', 'true');
      this.model.get('tippyConfig')?.onHide && this.model.get('tippyConfig').onHide(instance);
    };

    let tippyConfig = {
      allowHTML: false,
      interactive: true,
      aria: {
        content: 'describedby',
      },
      placement: 'top',
      trigger: 'click',
      hideOnClick: false,
      appendTo: `.btn-controlbar__popover-${this.model.get('cid')}-${this.model.get('id')}`,
      theme: 'custom-tooltip',
    };
    tippyConfig = {
      ...tippyConfig,
      ...this.model.get('tippyConfig'),
      onMount: onMount.bind(this),
      onShow: onShow.bind(this),
      onHide: onHide.bind(this),
    };

    if (tippyConfig.content instanceof HTMLElement) {
      tippyConfig.content.style.display = 'block';
      tippyConfig.allowHTML = true;
    }
    TippyService.add(`#${this.model.get('cid')}-${this.model.get('id')}`, tippyConfig, tippyConfig.allowHTML);
  },
});

export default ControlBarButtonAtomView;
